<script setup>
import HauptMenue from "../../components/HauptMenue.vue";
import FooterMenu from "../../components/FooterMenu.vue";
import DatenschutzHinweis from "../../components/DatenschutzHinweis.vue";
import DateInput from "../../components/DateInput.vue";
import ButtonSendDataSelfService from "../../components/ButtonSendDataSelfService.vue";
import ButtonResetServiceData from "../../components/ButtonResetServiceData.vue";
import CustomSelect from "../../components/CustomSelect.vue";
import CurrencyInput from "../../components/CurrencyInput.vue";
import DokumenteHochladen from "../../components/DokumenteHochladenService.vue";
import Alertbox from "../../components/Alertbox.vue";
import ButtonBack from "../../components/ButtonBack.vue";
import { store } from "../../components/store.vue";
import { onMounted } from "vue";
import { ersterDesFolgemonats, diffObj, pParseFloat, FloatToPString } from "../../utility";
/** View-Komponente zum Erfassen von Aufträgen zur Beitragsänderung
 * @displayName Selfservice Auftrag Beitragsänderung
 */
 </script>
<script>
export default {
  name: "SelfServiceAenderungBeitrag",

  components: {
    // myRouter: router,
    HauptMenue,
    FooterMenu,
    DatenschutzHinweis,
    DateInput,
    ButtonSendDataSelfService,
    ButtonResetServiceData,
    CustomSelect,
    CurrencyInput,
    Alertbox,
    ButtonBack,
  },
  data() {
    return {
      store,
      saved: false,
      sPMNROptions: this.$servertalk.getVbPMNROpts(
        store.selfService.AenderungBeitrag.ident
      ),
      sVersNrOptions: this.$servertalk.getVERSNROpts(
        store.selfService.AenderungBeitrag.ident
      ),
      sGesellschaftsformOptions: this.$servertalk.getSelectOpts("GESFORM"),
      abDatumOk:
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.GUELTIGAB
          .length == 10,
      beitragNeu: 0.0,
      beitragAlt: 0.0,
      beitragNeuOk: true,
      componentKeyAlt: 0,
      componentKeyNeu: 0,
      draftOrigin: null,
      draftChanged: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
  },
  unmounted() {
    if (this.saved) {
      // Nach Beauftragung Service in Draft komplett löschen
      delete store.subData.olddraft.sService.Entwuerfe.AenderungBeitrag;
      delete store.subData.draft.sService.Entwuerfe.AenderungBeitrag;
      this.saved = false;
    }
  },
  beforeCreate: function () {
    this.$servertalk.doLog("Create");
    this.$servertalk.doLog("Inhalt store:");
    this.$servertalk.doLog(store);
    let action = this.$servertalk.initSelfService(
      "AenderungBeitrag",
      '{"APANSPRNR":"", "PERSNR":"", "Vorname":"", "Nachname":"", "PMNR":"", "VERSNR":"","GUELTIGAB":"", "BEITRAGAKTUELL":"", "BEITRAGNEU":"0,00", "BEMERKUNG":"", "uploadsDokumente":[], "uuid":"", "version":"1.6"}',
      "1.6",
      store.subData
    );
    // Ermitteln des Index des aktuellen Mitarbeiters in subData
    this.Mitarbeiter = store.xSelectedMitarbeiter;
    let _BEITRAGAKTUELL = "0";
    //if (action % 2 == 1) {
    // olddraft wurde initialisiert
    this.$servertalk.doLog("olddraft wurde initialisiert");
    let olddraft = store.subData.olddraft.sService.Entwuerfe.AenderungBeitrag;
    olddraft.PERSNR = store.xSelectedMitarbeiter.PERSNR;
    olddraft.BEITRAGAKTUELL = _BEITRAGAKTUELL;
    olddraft.BEITRAGNEU = '0,00';
    olddraft.uuid = this.$servertalk.getUUID();
    //}

    //if (action >= 2) {
    this.$servertalk.doLog("draft wurde initialisiert");
    // draft wurde initialisiert
    this.$servertalk.copyToDraftSelfService("AenderungBeitrag", store.subData);
    //  }
  },
  created: function () {
    // Erforderlich für Anzeige von Änderungsaufträgen.
    let draft = store.subData.draft.sService.Entwuerfe.AenderungBeitrag;
    draft.APANSPRNR = store.masterData.data.Stammdaten.ANSPRNR;
    draft.GUELTIGAB = ersterDesFolgemonats();
    draft.Vorname = this.Mitarbeiter.VORNAME;
    draft.Nachname = this.Mitarbeiter.NAME;
    let _PMNR = this.$servertalk.getVbPMNR(
      store.selfService.AenderungBeitrag.ident
    );
    draft.PMNR = "-"; // Es existiert keine PMNR
    draft.VERSNR = "-"; // Es existiert keine VERSNR
    let _VERSNR = Array();
    if (_PMNR.length > 0) {
      draft.PMNR = _PMNR[0].PMNR; // Es existiert mindestens eine PMNR > die erste einstellen
      this.sVersNrOptions = this.$servertalk.getVERSNROpts(
        store.selfService.AenderungBeitrag.ident,
        draft.PMNR
      );
      _VERSNR = this.$servertalk.getVersicherungen(
        store.selfService.AenderungBeitrag.ident,
        draft.PMNR
      );
      if (_VERSNR.length == 2) {
        draft.VERSNR = _VERSNR[1].VERSNR; // Es existiert (genau) eine VERSNR > diese einstellen
      }
      if (_VERSNR.length > 2)
        draft.VERSNR = _VERSNR[0].VERSNR; // Es existieren mehrere VERSNRn > "alle" einstellen
      this.setVersicherungsnummer({ value: draft.VERSNR });
      if (_VERSNR.length == 2) {
        draft.BEITRAGAKTUELL = _VERSNR[1].BEITRAG;
        if (draft.BEITRAGAKTUELL.length > 0) {
          draft.BEITRAGAKTUELL = FloatToPString(pParseFloat(draft.BEITRAGAKTUELL)); // Korrektes Format einstellen für Clone
          draft.BEITRAGNEU = FloatToPString(pParseFloat(draft.BEITRAGAKTUELL) + 1.0);
        }
      }
    }
    this.draftOrigin = structuredClone(draft);
  },
  methods: {
    draftModified(oldData, draft) {
      this.draftChanged = false;
      if (typeof oldData != "undefined") {
        const dif = diffObj(this.draftOrigin, draft);
        this.draftChanged = Object.keys(dif).length > 0;
        this.$servertalk.doLog('dif: >>>', dif);
      }
    },
    forceRerender() {
      this.componentKeyAlt += 1;
      this.componentKeyNeu += 1;
    },
    docDocStatus(val) {
      this.$servertalk.doLog("docDocStatus: " + val.uploadStatus);
    },
    docDocOk(val) {
      this.$servertalk.doLog("docDocOk: " + val.uploadStatus);
    },
    changeFiles(val, i) {
      this.$servertalk.doLog("changeFiles");
      this.$servertalk.doLog(val);
      store.subData.draft.sService.Entwuerfe.AenderungBeitrag.uploadsDokumente =
        val;
    },
    abDatumChecked(val) {
      this.abDatumOk = val == "false" ? true : false;
    },
    beitragNeuChecked(val) {
      this.beitragNeuOk = val == "false" ? true : false;
    },
    setPMNR(val) {
      let draft =  store.subData.draft.sService.Entwuerfe.AenderungBeitrag
      if (val && typeof val === "object" && typeof val.value !== "undefined") {
      draft.PMNR =
          val.value + "";
        //this.$forceUpdate(); // Erzwingt ein erneutes Rendern der Komponente
        this.sVersNrOptions = this.$servertalk.getVERSNROpts(
          store.selfService.AenderungBeitrag.ident,
         draft.PMNR
        );
        let _VERSNR = this.$servertalk.getVersicherungen(
        store.selfService.AenderungBeitrag.ident,
        draft.PMNR
      );
      if (_VERSNR.length == 2) {
        draft.VERSNR = _VERSNR[1].VERSNR; // Es existiert (genau) eine VERSNR > diese einstellen
      }
      if (_VERSNR.length > 2)
        draft.VERSNR = _VERSNR[0].VERSNR; // Es existieren mehrere VERSNRn > "alle" einstellen
      this.setVersicherungsnummer({ value: draft.VERSNR });
      }
    },
    getSelectedBeitrag() {
      let draft = store.subData.draft.sService.Entwuerfe.AenderungBeitrag;
      let _VERSNR = this.$servertalk.getVersicherungen(
        store.selfService.AenderungBeitrag.ident,
        draft.PMNR
      );
      let vers = _VERSNR.find(v => v.VERSNR == store.subData.draft.sService.Entwuerfe.AenderungBeitrag.VERSNR);
      return (vers !== undefined) ? vers.BEITRAG : "0,00";
    },
    setVersicherungsnummer(val) {
      if (val && typeof val === "object" && typeof val.value !== "undefined") {
        let mySelfS = store.subData.draft.sService.Entwuerfe.AenderungBeitrag;
        mySelfS.VERSNR = val.value + "";
        //mySelfS.BEITRAGAKTUELL = this.getSelectedBeitrag();
        this.beitragAlt = pParseFloat(this.getSelectedBeitrag());

        this.$servertalk.doLog('##SelBeitrag', mySelfS.BEITRAGAKTUELL);
        this.$servertalk.doLog('##B2', this.beitragAlt);

        //this.beitragAlt = this.getSelectedBeitrag();


        this.$servertalk.doLog('##myVers 2', store.subData.draft.sService.Entwuerfe.AenderungBeitrag);

        this.forceRerender();

        //this.$forceUpdate(); // Erzwingt ein erneutes Rendern der Komponente
      }
    },
    sendDataFinished() {
      let messageCode = this.$servertalk.sendDataSelfService(
        "AenderungBeitrag",
        store.subData
      );
      store.message =
        messageCode == 0
          ? {
            text: "Ihre Änderungen im Bereich\n Beitragserhöhung \n wurden erfolgreich beauftragt.",
            status: "ok",
          }
          : {
            text:
              "Beim Speichern des Auftrags im Bereich\n Beitragserhöhung \n trat ein Fehler auf (Error-Code " +
              messageCode +
              ").",
            status: "error",
          };
      if (messageCode == 0) this.saved = true;
      this.$router.push("/mitarbeiterdaten");
    },
    resetData() {
      //this.$refs.SelectFamStand.reset(); // Zurücksetzen Select
      let messageCode = this.$servertalk.copyToDraftSelfService(
        "AenderungBeitrag",
        store.subData
      );
      this.draftOrigin = structuredClone(store.subData.draft.sService.Entwuerfe.AenderungBeitrag);
      store.message =
        messageCode == 0
          ? {
            text: "Ihre Änderungen im Bereich\n Änderung Beitrag \n wurden zurückgesetzt.",
            status: "ok",
          }
          : {
            text:
              "Beim Zurücksetzen der Daten im Bereich\n Änderung Beitrag \n trat ein Fehler auf (Error-Code " +
              messageCode +
              ").",
            status: "error",
          };
    },
  },
  watch: {
    "store.subData.draft.sService.Entwuerfe.AenderungBeitrag": {
      handler(newData, oldData) {
        this.draftModified(oldData, store.subData.draft.sService.Entwuerfe.AenderungBeitrag);
      },
      deep: true,
    },
    beitragNeu(newValue) {
      this.$servertalk.doLog('##BeitragNeu', newValue);
      if (newValue == null || newValue == "") {
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGNEU =
          '0,0'; // Setze auf einen Standardwert
      } else {
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGNEU =
          FloatToPString(newValue);
      }
      //this.beitragNeu = pParseFloat(store.subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGNEU);
    },
    beitragAlt(newValue) {
      this.$servertalk.doLog('##BeitragAlt', newValue);
      if (newValue == null || newValue == "") {
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGAKTUELL =
          '0,0'; // Setze auf einen Standardwert
      } else {
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGAKTUELL = FloatToPString(newValue);
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGNEU = FloatToPString(newValue + 1.0);
      }
      //this.beitragAlt = pParseFloat(store.subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGAKTUELL);
    },
  },
  computed: {

    getVersBeginn() {
      let dateVersBeg = "-14";
      let versNr =
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.VERSNR;
      let versNrn = this.$servertalk.getVERSNROpts(
        store.selfService.AenderungBeitrag.ident,
        store.subData.draft.sService.Entwuerfe.AenderungBeitrag.PMNR
      );
      let idxVersnr = versNrn.findIndex((nr) => nr.text == versNr);
      if (idxVersnr >= 0) {
        let _VERSNR = this.$servertalk.getVersicherungen(
          store.selfService.AenderungBeitrag.ident,
          store.subData.draft.sService.Entwuerfe.AenderungBeitrag.PMNR
        );
        dateVersBeg = _VERSNR[idxVersnr].VERSBEG;
      }
      return dateVersBeg;
    },
    setSchwebendClass() {
      // Erhalte den Wert "Privatadresse" von $servertalk
      //const aenderung = this.$servertalk.gettAttr("fadata.Firmenstammdaten");
      //const aenderungPrivatadresseValue = this.$servertalk.gettAttr("subData.draft.sService.Entwuerfe.AenderungKontaktdaten");
      return null;
    },
    setStatusClass() {
      // Erhalte den Wert "AenderungBeitrag" von $servertalk
      const AenderungBeitragdatenValue = this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.AenderungBeitrag"
      );
      return AenderungBeitragdatenValue;
    },
    setStatusClassPMNR() {
      // Erhalte den Wert "PMNR" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.AenderungBeitrag.PMNR"
      );
    },
    setStatusClassVERSNR() {
      // Erhalte den Wert "VERSNR" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.AenderungBeitrag.VERSNR"
      );
    },
    setStatusClassBEMERKUNG() {
      // Erhalte den Wert "BEMERKUNG" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.AenderungBeitrag.BEMERKUNG"
      );
    },
    setStatusClassGUELTIGAB() {
      // Erhalte den Wert "GUELTIGAB" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.AenderungBeitrag.GUELTIGAB"
      );
    },
    setStatusClassBEITRAGAKTUELL() {
      // Erhalte den Wert "BEITRAGAKTUELL" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGAKTUELL"
      );
    },
    setStatusClassBEITRAGNEU() {
      // Erhalte den Wert "BEITRAGNEU" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.AenderungBeitrag.BEITRAGNEU"
      );
    },
    combinedFirmenstammdaten() {
      // Kombiniert FKENNR und FABRGR aus dem Store und trennt mit "/"
      const { FKENNR, FABRGR } = store.subData.data.Firmenstammdaten;
      return `${FKENNR || ""}/${FABRGR || ""}`;
    },
    versNrValid() {
      const val =
        this.store.subData.draft.sService.Entwuerfe.AenderungBeitrag.VERSNR;
      return val && val !== "" && val !== "Bitte auswählen";
    },
    //Doppelt, siehe oben
    //setStatusClassVERSNR() { 
    //  let val = this.store.subData.draft.sService.Entwuerfe.AenderungBeitrag.VERSNR;
    //  if (!val || val === "Bitte auswählen") return "border-red-500";
    //},
  },
};
</script>
<template>
  <div class="main-wrapper" :class="store.accessRestriction">
    <HauptMenue />
    <div>
      <div class="mt-36 md:mt-48 lg:mt-56 max-w-7xl mx-auto">
        <div class="max-w-5xl mx-auto mb-8 px-5 lg:px-0">
          <h1 class="text-primary/75 font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center mb-12 uppercase">
            Antrag auf Beitragserhöhung für
            <br />
            <span>
              "{{ store.subData.data.Firmenstammdaten.FNAME }}
              {{
                $servertalk.getName(
                  "GESFORM",
                  store.subData.data.Firmenstammdaten?.FGESFORM
                )
              }}
              {{ store.subData.data.Firmenstammdaten.FKENNR }}/{{
                store.subData.data.Firmenstammdaten.FABRGR
              }}"
            </span>
            <br />
            <span>
              <h2 class="text-primary/75 font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-12">
                {{ store.xSelectedMitarbeiter.VORNAME }}
                {{ store.xSelectedMitarbeiter.NAME }}
                melden
              </h2>
            </span>
          </h1>
          <!--modal content-->
          <Alertbox />
          <div class="status-label mb-8" v-if="setStatusClass === 'modified'">
            <span class="bearbeitung bg-yellow-400 text-tertiary inline-block py-1 px-2 text-sm uppercase mb-2">
              Entwurf
            </span>
            <span class="infotext text-tertiary text-sm block">
              Dies ist ein Entwurf. Bitte bestätigen Sie diesen
              Änderungsauftrag, indem Sie unten auf
              <strong>Beantragen</strong>
              klicken.
            </span>
          </div>
          <form :class="setStatusClass">
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-6">
                <div v-if="sPMNROptions.length > 1">
                  <CustomSelect 
                  @input="setPMNR" 
                  class="select" 
                  :class="setStatusClassPMNR" 
                  required
                  label="PMNR"
                  :options="sPMNROptions" 
                  :default="store.subData.draft.sService.Entwuerfe.AenderungBeitrag.PMNR" 
                  :oldDefault="store.subData.olddraft?.sService.Entwuerfe.AenderungBeitrag.PMNR" 
                  hideReset="false" 
                  useArrowIcon="true"
                  placeholder="Keine" />
                </div>
                <div v-else>
                  <label for="fixPMNR" class="text-sm mb-2 block">PMNR</label>
                  <input id="fixPMNR"
                    class="w-full p-3 border rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 border-secondary/50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                    :class="setStatusClassPMNR" type="text" v-model="store.subData.draft.sService.Entwuerfe.AenderungBeitrag
                      .PMNR
                      " disabled />
                </div>
              </div>
              <div class="relative lg:col-span-6">
                <div v-if="sVersNrOptions.length > 2">
                  <CustomSelect
                  @input="setVersicherungsnummer"
                  class="select"
                  :class="setStatusClassVERSNR"
                  inputClass="border-red-500"
                  label="Versicherungsnummer"
                  id="versicherungsnummer"
                  required
                  :options="sVersNrOptions"
                  :default="store.subData.draft.sService.Entwuerfe.AenderungBeitrag.VERSNR" 
                  :oldDefault="store.subData.olddraft?.sService.Entwuerfe.AenderungBeitrag.VERSNR"
                  hideReset="false"
                  useArrowIcon="true"
                  placeholder="Keine" />
                </div>
                <div v-else>
                  <label for="fixVERSNR" class="text-sm mb-2 block">
                    Versicherungsnummer
                  </label>
                  <input id="fixVERSNR"
                    class="w-full p-3 border rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 border-secondary/50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                    :class="setStatusClassVERSNR"
                    type="text"
                    v-model="store.subData.draft.sService.Entwuerfe.AenderungBeitrag.VERSNR"
                    disabled />
                </div>
              </div>
            </div>
            <div class="grid lg:grid-cols-12 sm:gap-5">
              <div class="relative lg:col-span-6">
                <label for="aendVorname" class="text-sm mb-2 block">
                  Vorname der versicherten Person
                </label>
                <input maxlength="100" type="text" id="aendVorname"
                  class="peer w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                  v-model="store.xSelectedMitarbeiter.VORNAME" disabled="true" />
              </div>
              <div class="relative lg:col-span-6">
                <label for="aendName" class="text-sm mb-2 block">
                  Name der versicherten Person
                </label>
                <input maxlength="100" type="text" id="aendName"
                  class="peer w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                  v-model="store.xSelectedMitarbeiter.NAME" disabled="true" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-6">
                <label for="aendGueltigAb" class="text-sm mb-2 block">
                  Die Änderung ist gültig ab:
                  <sup>*</sup>
                </label>
                <DateInput :statusClass="setStatusClassGUELTIGAB" name="aendGueltigAb" placeholder="gültiges Datum"
                  id="aendGueltigAb" :required="true" :disabled="false" dmax="+730" :dmin="getVersBeginn" v-model="store.subData.draft.sService.Entwuerfe.AenderungBeitrag
                    .GUELTIGAB
                    " @dateChecked="abDatumChecked" :class="{ invalid: !abDatumOk }" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-6">
                <CurrencyInput :key="componentKeyAlt" :model-value="beitragAlt" :options="{
                  currency: 'EUR',
                  precision: 2,
                  hideCurrencySymbolOnFocus: false,
                  useGrouping: true,
                }" :statusClass="setStatusClassBEITRAGAKTUELL" name="aendBeitragAktuell" placeholder=""
                  label="Beitrag aktuell:" id="beitragaktuell" :disabled="true" />
              </div>
              <div class="relative lg:col-span-6">
                <CurrencyInput :key="componentKeyNeu" v-model="beitragNeu" :options="{
                  locale: 'de-DE',
                  currency: 'EUR',
                  precision: 2,
                  autoDecimalMode: true,
                  useGrouping: true,
                  hideCurrencySymbolOnFocus: true,
                  valueRange: {
                    min:
                      beitragAlt + 1.0,
                  },
                  allowNegative: false,
                }" :statusClass="setStatusClassBEITRAGNEU" name="aendBeitragNeu" placeholder="" id="aendBeitragNeu"
                  :disabled="false" label="Neue Beitragshöhe:" :required="true" @valChecked="beitragNeuChecked" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5 mt-5">
              <div class="relative lg:col-span-12">
                <label for="aendBemerkung" class="text-sm mb-2 block">
                  Bemerkung
                </label>
                <textarea
                  class="w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 focus:border-tertiary/50 peer invalid:text-red-500 focus:invalid:border-red-500"
                  :class="setStatusClassBEMERKUNG" rows="5" v-model="store.subData.draft.sService.Entwuerfe.AenderungBeitrag
                    .BEMERKUNG
                    "></textarea>
              </div>
            </div>
            <div>
              <div class="text-sm mb-2 block">Dokumente</div>
              <DokumenteHochladen :isSubdata="true" :formId="store.subData.draft.sService.Entwuerfe.AenderungBeitrag.uuid
                " :defaultData="store.subData.draft.sService.Entwuerfe.AenderungBeitrag
                  .uploadsDokumente
                  " maxfiles="10" minfiles="0" infoText="AenderungBeitragData" docArt="Docs" @status="docDocStatus"
                @isOk="docDocOk" @newfiles="changeFiles" @change="changeFiles" />
            </div>
            <div class="anmerkung mb-4 p-4 bg-primary/10 rounded-md text-sm">
              <p>
                Sofern es sich bei der Person um eine GGF-Versorgung handelt,
                übersenden Sie uns bitte zusätzlich den GGF-Beschluss
                <br />
                Die Umsetzung des Antrags erfolgt nach positiver Prüfung
              </p>
            </div>
            <div class="button-wrapper flex justify-center gap-4 [&>button]:mx-0">
              <ButtonSendDataSelfService label="Beantragen" :disabled="store.subData.isReadOnly ||
                !beitragNeuOk ||
                !abDatumOk ||
                !versNrValid
                " @finished="sendDataFinished" />
            </div>
          </form>
          <ButtonBack :confirm="draftChanged" />
          <DatenschutzHinweis />
        </div>
      </div>
    </div>

    <FooterMenu />
  </div>
</template>
